import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ContentWithCardLoading } from "../../../../components/loading";
import AdvanceDataTable from "../../../../components/normal-table/advance-table";
import ContentWrapper from "../../../Wrapper";
import GatewayAndPriceSubheader from "../../components/gateway-and-price-subheader";
import * as rcsPriceActions from "../../store/actions/gateway_and_price_list_rcs_actions";
import RcsPriceSidePanel from "../../components/rcs-price-side-panel";

const GATEWAY_AND_PRICE_ACTIONS = {
  NONE: "NONE",
  EDIT: "EDIT",
};

export default function RCSPriceList() {
  const tabName = "RCS Pricing";
  const [selectedGatewayAndPriceWithAction, setSelectedGatewayAndPriceWithAction] = useState({
    action: GATEWAY_AND_PRICE_ACTIONS.NONE,
    data: {},
  });
  const [limit, setLimit] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const [search, setSearch] = useState("");

  const dispatch = useDispatch();

  const rcsStore = useSelector((state) => state.gatewayAndPrice.rcs);

  useEffect(() => {
    dispatch(rcsPriceActions.getListOfRCSPriceRequest({ limit: limit, page: pageNo, search: search }));
  }, [dispatch, limit, pageNo, search]);

  return (
    <ContentWrapper subHeader={<GatewayAndPriceSubheader tabName={tabName} >
      <Form.Control placeholder="Search country here..." style={{ width: "300px" }} value={search} onChange={e => setSearch(e.target.value)} />
    </GatewayAndPriceSubheader>}>
      {rcsStore.loading ? (
        <ContentWithCardLoading />
      ) : rcsStore.data.length === 0 ? (
        "No accounts"
      ) : (
        <div className={`card card-custom`}>
          <div className="card-body py-3 px-3" style={{ padding: 15 }}>
            <AdvanceDataTable
              columns={[
                { title: "Route Name", apiKeyName: "route", fieldInputType: "INPUT" },
                { title: "Country Name", apiKeyName: "countryName", fieldInputType: "INPUT" },
                { title: "Country ISO", apiKeyName: "countryIso", fieldInputType: "INPUT" },
                { title: "Currency", apiKeyName: "currency", fieldInputType: "INPUT" },
                { title: "Price", apiKeyName: "price", fieldInputType: "INPUT" },
                { title: "Actions", isAction: true, options: ["edit"] },
              ]}
              data={rcsStore.data}
              limit={limit}
              pageNo={pageNo}
              setLimit={setLimit}
              setPageNo={setPageNo}
              count={rcsStore.count}
              // actions
              handleEdit={(data) => setSelectedGatewayAndPriceWithAction({ action: GATEWAY_AND_PRICE_ACTIONS.EDIT, data })}
            />
          </div>
          <RcsPriceSidePanel
            show={selectedGatewayAndPriceWithAction.action === GATEWAY_AND_PRICE_ACTIONS.EDIT}
            gatewayAndPriceData={selectedGatewayAndPriceWithAction.data}
            loadingData={{ limit, page: pageNo }}
            handleClose={() => setSelectedGatewayAndPriceWithAction({ action: GATEWAY_AND_PRICE_ACTIONS.NONE, data: {} })}
          />
        </div>
      )}
    </ContentWrapper>
  );
}
